import { render, staticRenderFns } from "./onebox-fileexpired.vue?vue&type=template&id=4e8c3368&"
import script from "./onebox-fileexpired.vue?vue&type=script&lang=js&"
export * from "./onebox-fileexpired.vue?vue&type=script&lang=js&"
import style0 from "./onebox-fileexpired.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports